import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { AnyAction } from 'redux';

export const hauptfaelligkeitReducer = function (
  sectionState: string = null,
  action: AnyAction,
): string {
  switch (action.type) {
    case GlobalActions.HAUPTFAELLIGKEIT_CHANGED: {
      return action.payload + '';
    }
    default:
      return sectionState;
  }
};
